jQuery(function ($) {
    console.log('gravityform-customscripts running...');
    // Prevent the Enter key from submitting specific Gravity Forms (IDs: 98, 12, 1)
    // unless the focus is inside a textarea or a submit/button input.
    var targetWrappers = ['#gform_wrapper_98', '#gform_wrapper_12', '#gform_wrapper_1'];

    $(document).on('keypress', targetWrappers.join(', '), function (e) {
        var code = e.keyCode || e.which;
        if (code === 13 && !$(e.target).is('textarea,input[type="submit"],input[type="button"]')) {
            e.preventDefault();
            return false;
        }
    });


});


